import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import UserManager from './UserManager';
import { decodeJwtPayload } from './JwtStore';

const localStorageLanguageCodeKey = 'userLanguageCode';
const DEFAULT_LANGUAGE_CODE = 'en_UK';

function getLanguageCodeFromJWT(jwt) {
  return decodeJwtPayload(jwt)['language'] || DEFAULT_LANGUAGE_CODE;
}

class UserStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      iss: undefined,
      exp: undefined,
      username: undefined,
      firstName: undefined,
      lastName: undefined,
      isAdmin: undefined,
      brands: undefined,
      roles: undefined,
      displayName: undefined,
      lastLoginAt: undefined,
      hasNews: undefined,
      language: {
        name: undefined,
        // @todo 2018-09-03
        // I don't really like how the language has been handled. Consider
        // making a UserLanguageStore, maybe.
        code: window.sessionStorage.getItem(localStorageLanguageCodeKey) || DEFAULT_LANGUAGE_CODE,
      },
    };
  }

  getLanguageCode() {
    const state = this.getState();

    return state.language.code;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.USER_STORE_FETCH:
        UserManager.fetch();
        return state;

      case ActionTypes.USER_STORE_UPDATE_LANGUAGE:
        UserManager.updateLanguage(action.language);
        return state;

      case ActionTypes.USER_STORE_FETCH_COMPLETED:
      case ActionTypes.USER_STORE_UPDATE_LANGUAGE_COMPLETED:
        const nextState = action.user;

        if (action.user.language === null) {
          nextState.language = state.language;
        } else {
          window.sessionStorage.setItem(localStorageLanguageCodeKey, action.user.language.code);
        }

        return nextState;

      case ActionTypes.LOGIN_COMPLETED:
      case ActionTypes.JWT_LOGIN_COMPLETED:
        const languageCode = getLanguageCodeFromJWT(action.token);

        const language = {
          code: languageCode,
          name: state.language.name,
        };

        window.sessionStorage.setItem(localStorageLanguageCodeKey, languageCode);

        return Object.assign(state, { language });

      default:
        return state;
    }
  }
}

export default new UserStore();
